// library
import React, { 
    FC
} from "react";
import _ from "lodash";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
        props: TransitionProps & {
            children: React.ReactElement<unknown>;
        },
        ref: React.Ref<unknown>,
    ) {
        return <Slide direction="up" ref={ref} {...props} />;
    });

/**
 * 都道府県変更ダイアログ
 * @param props 
 * @returns 
 */
const PrefectureDialog: FC<any> = ( props: { 
    config:any,
    isOpenPrefecture: boolean,
    setIsOpenPrefecture: any,
    selectPrefecture: number,
    setSelectPrefecture: any,
    initStart: any,
}) => {
    const { 
        config, 
        isOpenPrefecture, 
        setIsOpenPrefecture,
        selectPrefecture,
        setSelectPrefecture,
        initStart,
    } = props;

    const prefectures = config.code_master.pref;

    /**
     * 変更ボタンを押下した時
     */
    const changePrefecture = () => {
        initStart();
        setIsOpenPrefecture(false);
    }

    /**
     * ダイアログを閉じた時
     */
    const closePrefectureDialog = () => {
        setSelectPrefecture(null);
        setIsOpenPrefecture(false)
    }

    return (
        <React.Fragment>
            <Dialog
                fullScreen
                open={isOpenPrefecture}
                onClose={closePrefectureDialog}
                TransitionComponent={Transition}
            >
                <AppBar 
                    color="success" 
                    sx={{ position: 'fixed', top: 0, left: 0, width: '100%' }}
                >
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={closePrefectureDialog}
                            aria-label="close"
                        >
                        <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            都道府県選択
                        </Typography>
                        <Button 
                            autoFocus 
                            color="inherit" 
                            onClick={() => changePrefecture()}
                            disabled={selectPrefecture === null}
                        >
                            変更
                        </Button>
                    </Toolbar>
                </AppBar>
                <List
                    sx={{ paddingTop: '60px' }}
                >
                    {_.map(prefectures, prefecture => (
                        <React.Fragment key={prefecture.cd}>
                            <ListItemButton
                                onClick={() => setSelectPrefecture(prefecture.cd)}
                                className={selectPrefecture === prefecture.cd ? "prefecture-selected forced" : ""}
                            >
                                <ListItemText primary={prefecture.name} secondary={prefecture.name2} />
                                {/* <ListItemText primary={prefecture.name} secondary="Titania" /> */}
                            </ListItemButton>
                            <Divider />
                        </React.Fragment>
                        ))
                    }
                </List>
            </Dialog>
        </React.Fragment>
    );
}

export default PrefectureDialog;